module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex styleHeader"
  }, [(_vm.canBack) ? _c('button', {
    staticClass: "buttonBack",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onBack
    }
  }, [(_vm.isCross) ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.9663 11.1996L8.43334 6.66667L12.9663 2.13371C13.4557 1.64432 13.4557 0.856436 12.9663 0.367044C12.4769 -0.122348 11.689 -0.122348 11.1996 0.367044L6.66667 4.9L2.13371 0.367044C1.64432 -0.122348 0.856436 -0.122348 0.367044 0.367044C-0.122348 0.856436 -0.122348 1.64432 0.367044 2.13371L4.9 6.66667L0.367044 11.1996C-0.122348 11.689 -0.122348 12.4769 0.367044 12.9663C0.856436 13.4557 1.64432 13.4557 2.13371 12.9663L6.66667 8.43334L11.1996 12.9663C11.689 13.4557 12.4769 13.4557 12.9663 12.9663C13.4522 12.4769 13.4522 11.6855 12.9663 11.1996Z",
      "fill": "#1B1918"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.9141 19.5312L4.88281 12.5L11.9141 5.46875",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.85938 12.5H20.1172",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-center"
  }, [_c('span', {
    staticClass: "DeclarationUBO"
  }, [_vm._v(" " + _vm._s(_vm.title))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-028c1c98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028c1c98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/HeaderBack.vue
// module id = 2314
// module chunks = 2